"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const redux_form_1 = require("redux-form");
const edit_2_svg_1 = __importDefault(require("images/utility-icons/edit-2.svg"));
const utils_1 = require("utils");
function RadioButtonEditableInput({ id, checked, radioGroupName, initialValue, onChange, labelPrefix, labelSuffix, editField, format, }) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const [editing, setEditing] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    const radioRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if ((0, utils_1.isPresent)(initialValue))
            setValue(initialValue);
    }, [initialValue]);
    const saveValue = () => {
        if (inputRef.current) {
            setValue(inputRef.current.value);
        }
        if (inputRef.current && radioRef.current && radioRef.current.checked) {
            onChange(inputRef.current.value);
        }
        setEditing(false);
        return false;
    };
    const formatValue = (value) => {
        if (format) {
            return format(value);
        }
        else {
            return value;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("fieldset", { className: "m-t-10", children: [(0, jsx_runtime_1.jsx)("div", { className: "input-wrapper", children: (0, jsx_runtime_1.jsx)("input", { ref: radioRef, type: "radio", id: id, name: radioGroupName, value: value, defaultChecked: checked, onClick: () => onChange(value) }) }), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsxs)("label", { htmlFor: id, className: "", children: [labelPrefix, " ", formatValue(value), " ", labelSuffix] }) }), (0, jsx_runtime_1.jsx)("span", { onClick: () => setEditing(!editing), tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                setEditing(!editing);
                            }
                        }, role: "button", style: { paddingLeft: '3%', cursor: 'pointer' }, children: (0, jsx_runtime_1.jsx)("img", { src: edit_2_svg_1.default, alt: "", style: { height: '20px', width: '20px' } }) })] }), editing && ((0, jsx_runtime_1.jsxs)("div", { className: "editableInput m-t-10", children: [(0, jsx_runtime_1.jsx)(redux_form_1.Field, { component: editField.component, inputType: editField.inputType, required: true, requiredIndicator: " *", ref: inputRef, parse: editField.parse, name: editField.name, placeholder: editField.placeholder, maskOptions: editField.maskOptions }), (0, jsx_runtime_1.jsx)(lp_components_1.SubmitButton, { onClick: saveValue, className: "button-warn-outline", children: "SAVE" })] }))] }));
}
exports.default = (0, react_1.memo)(RadioButtonEditableInput);
